import { createReducer, on } from '@ngrx/store';
import { priceActions } from '../actions/price.actions';
import { Rate } from '@app/store/models';
import { Pricing } from '../models';

export interface PriceState {
    chain: {
        loaded: boolean | null;
        loading: boolean | null;
        value: Pricing | null;
    };
    store: {
        loaded: boolean | null;
        loading: boolean | null;
        value: Pricing | null;
    };
    exchanges: {
        loaded: boolean | null;
        loading: boolean | null;
        rates: Record<string, Rate>;
    };
}

export const initialState: PriceState = {
    chain: {
        loaded: false,
        loading: false,
        value: null,
    },
    store: {
        loaded: false,
        loading: false,
        value: null,
    },
    exchanges: {
        loaded: false,
        loading: false,
        rates: {},
    },
};

export const priceReducer = createReducer(
    initialState,
    on(
        priceActions.getChainPrice,
        (state): PriceState => ({
            ...state,
            chain: {
                ...state.chain,
                loading: true,
            },
        }),
    ),
    on(
        priceActions.getChainPriceSuccess,
        (state, action): PriceState => ({
            ...state,
            chain: {
                ...state.chain,
                loading: false,
                loaded: true,
                value: action.payload,
            },
        }),
    ),
    on(
        priceActions.getChainPriceError,
        (state): PriceState => ({
            ...state,
            chain: {
                ...state.chain,
                loading: false,
            },
        }),
    ),
    on(
        priceActions.getStorePrice,
        (state): PriceState => ({
            ...state,
            store: {
                ...state.store,
                loading: true,
            },
        }),
    ),
    on(
        priceActions.getStorePriceSuccess,
        (state, action): PriceState => ({
            ...state,
            store: {
                ...state.store,
                loading: false,
                loaded: true,
                value: action.payload,
            },
        }),
    ),
    on(
        priceActions.getStorePriceError,
        (state): PriceState => ({
            ...state,
            store: {
                ...state.store,
                loading: false,
            },
        }),
    ),
    on(
        priceActions.getExchangeRates,
        (state): PriceState => ({
            ...state,
            exchanges: {
                ...state.exchanges,
                loading: true,
            },
        }),
    ),
    on(
        priceActions.getExchangeRatesSuccess,
        (state, action): PriceState => ({
            ...state,
            exchanges: {
                ...state.exchanges,
                loading: false,
                loaded: true,
                rates: action.payload.rates,
            },
        }),
    ),
    on(
        priceActions.getExchangeRatesError,
        (state): PriceState => ({
            ...state,
            exchanges: {
                ...state.exchanges,
                loading: false,
                loaded: true,
            },
        }),
    ),
    on(
        priceActions.clear,
        (): PriceState => ({
            ...initialState,
        }),
    ),
);
